




























































































import {Prop, Component, Vue, Emit} from "vue-property-decorator";
import {mapGetters} from "vuex";
import User from "@/consoleapi/api/user";
import Sidebar from "@/components/Sidebar.vue";

@Component({
  components:{
    Sidebar,
  },
  computed:
          mapGetters({
            pageTitle: 'title/pageTitle'
          }),
})
export default class App extends Vue {
  public userName = 'ゲスト';
  public mailAddress = '';
  public phoneNumber = '';

  public bearerToken = this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN));
  public refreshToken = this.$cookies.get(String(process.env.VUE_APP_COOKIE_REFRESH_TOKEN));
  public accountId = this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID));
  public userId = this.$cookies.get(String(process.env.VUE_APP_COOKIE_COGNITO_USER_NAME));

  public inputOutstandingInvoiceId = "";

  @Prop() public isSidebarHidden!: boolean;

  mounted() {
    this.getUser();
  }

  beforeUpdate() {
      if(!this.accountId) {
          this.accountId = this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID));
      }
      if(this.userName === 'ゲスト' && this.mailAddress === '' && this.phoneNumber === ''){
          this.getUser();
      }
  }

  private getUser(){
      const user = new User();
      user.setBearerToken(this.bearerToken);
      user.show(this.accountId, this.userId)
          .then(response => {
              this.userName = response.data.user.name;
              this.mailAddress = response.data.user.mailAddress;
              this.phoneNumber = response.data.user.phoneNumber;
          });
  }

  public getOutstandingInvoiceId(inputOutstandingInvoiceId: string) {
    this.inputOutstandingInvoiceId = inputOutstandingInvoiceId;
  }
}
